import { s as t } from "../styled-a6aa6ca0.js";
import "../createTheme-ef7fa3a1.js";
import "../objectWithoutPropertiesLoose-1e2b28af.js";
import "../_commonjsHelpers-c5d32002.js";
import "../extends-e3d0fd9d.js";
import "../extends-0a3e0827.js";
import "../index-057d60ee.js";
import "../extendSxProp-10687d60.js";
import "@emotion/styled";
import "@emotion/react";
import "react";
import "react/jsx-runtime";
import "../GlobalStyles-bdd9f9fb.js";
import "../defaultTheme-9f1e13f4.js";
import "../identifier-2b569a98.js";
const x = t;
export {
  x as default
};
//# sourceMappingURL=styled.js.map
